<template>
    <v-container fluid>
        <v-row class="align-start mb-0">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[
                    { text: 'Home', disable: false, href: '/#/' },
                    {
                        text: 'Greenhouses',
                        disabled: false,
                        href: '/#/greenhouses'
                    },
                    { text: greenhouse.name, disable: true }
                ]"
                divider="/"
            ></v-breadcrumbs>
        </v-row>

        <!-- Add department dialog -->
        <GreenhouseDepartmentEditDialog
            :dialog.sync="editGreenhouseDepartmentDialog"
            :greenhouseNodeId="greenhouse.id"
            v-on:item-created="onDepartmentAdded"
        ></GreenhouseDepartmentEditDialog>

        <!-- Add section dialog -->
        <GreenhouseDepartmnetSectionAddDialog
            :dialog.sync="addGreenhouseDepartmentSectionDialog"
            :selectedDepartmentNode="selectedDepartmentNode"
            v-on:item-created="onAddDepartmentSectionsConfirmed"
        ></GreenhouseDepartmnetSectionAddDialog>

        <!-- Add growth task dialog -->
        <GrowthTaskEditDialog
            :dialog.sync="growthTaskEditDialog"
            v-on:item-created="onAddGrowthTaskConfirmed"
        ></GrowthTaskEditDialog>

        <!-- Section growth tasks dialog -->
        <GreenhouseDepartmnetSectionTasksDialog
            :dialog.sync="sectionDetaildialog"
            :selectedSectionNodeId="selectedSectionNodeId"
        ></GreenhouseDepartmnetSectionTasksDialog>

        <!-- Delete Dialog -->
        <DeleteDialog
            :dialog.sync="deleteItemDialog"
            :item="deletingItem"
            v-on:confirmed="onDeleteConfirmed"
        >
            <template v-slot:title
                >Delete -
                {{
                    deletingItem.object ? deletingItem.object.name : ""
                }}</template
            >
            <template v-slot:content>
                Are you sure you want to delete
                <b>{{ deletingItem.object ? deletingItem.object.name : "" }}</b
                >?
            </template>
        </DeleteDialog>

        <v-row class="ma-0">
            <v-col cols="12" class="pa-0" ref="layout">
                <v-row>
                    <v-col cols="12" md="8" class="py-0 pr-0">
                        <!-- toolbar normal -->
                        <v-toolbar
                            v-if="!isEditing"
                            dense
                            flat
                            outlined
                            class="pa-0"
                        >
                            <v-btn
                                v-if="hasPermission('add_growthtask')"
                                class="ml-n3 mr-1"
                                tile
                                outlined
                                small
                                color="primary"
                                @click="growthTaskEditDialog = true"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on">eco</v-icon>
                                    </template>
                                    <span>New GrowthTask</span>
                                </v-tooltip>
                            </v-btn>
                            <v-btn
                                v-if="hasPermission('change_greenhouse')"
                                tile
                                outlined
                                small
                                color="primary"
                                @click="onStartEditing"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on">edit</v-icon>
                                    </template>
                                    <span>Edit</span>
                                </v-tooltip>
                            </v-btn>
                        </v-toolbar>

                        <!-- toolbar editing -->
                        <v-toolbar
                            v-if="isEditing"
                            dense
                            flat
                            outlined
                            class="pa-0"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        v-on="on"
                                        small
                                        color="primary"
                                        icon
                                        :disabled="!hasUnsavedChange"
                                        :loading="isSaving"
                                        @click="saveEditing"
                                    >
                                        <v-icon>save</v-icon>
                                    </v-btn>
                                </template>
                                <span>Save</span>
                            </v-tooltip>
                            <v-btn
                                small
                                color="primary"
                                text
                                :disabled="disableAddDepartmentButton"
                                @click="onAddDepartment"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on">border_outer</v-icon>
                                    </template>
                                    <span>Add Department</span>
                                </v-tooltip>
                            </v-btn>
                            <v-btn
                                small
                                color="primary"
                                text
                                :disabled="disableAddSectionButton"
                                @click="onAddDepartmentSections"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on">select_all</v-icon>
                                    </template>
                                    <span>Add Section</span>
                                </v-tooltip>
                            </v-btn>
                            <!-- <v-btn
                                small
                                color="primary"
                                text
                                :disabled="disableCopySectionButton"
                                v-if="isEditing"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on">file_copy</v-icon>
                                    </template>
                                    <span>Copy Section</span>
                                </v-tooltip>
                            </v-btn>-->
                            <v-btn
                                small
                                color="error"
                                text
                                @click="onCancelEditing"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on"
                                            >not_interested</v-icon
                                        >
                                    </template>
                                    <span>Cancel</span>
                                </v-tooltip>
                            </v-btn>
                        </v-toolbar>
                    </v-col>

                    <v-col cols="12" md="4" class="py-0 pl-0">
                        <!-- toolbar zoom -->
                        <v-toolbar dense flat outlined class="pa-0">
                            <v-btn
                                color="primary"
                                text
                                small
                                @click="fitWidnowSize(greenhouse)"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on"
                                            >fullscreen_exit</v-icon
                                        >
                                    </template>
                                    <span>Fit</span>
                                </v-tooltip>
                            </v-btn>
                            <v-slider
                                class="mt-6"
                                v-model="scale"
                                min="0.05"
                                max="2"
                                step="0.01"
                                thumb-label
                                :thumb-size="24"
                                append-icon="zoom_in"
                                prepend-icon="zoom_out"
                                @click:append="zoomIn"
                                @click:prepend="zoomOut"
                            ></v-slider>
                            <v-btn
                                color="primary"
                                text
                                small
                                @click="originalWidnowSize"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on">fullscreen</v-icon>
                                    </template>
                                    <span>100%</span>
                                </v-tooltip>
                            </v-btn>
                        </v-toolbar>
                    </v-col>
                </v-row>

                <!-- layout frame -->
                <div
                    ref="frameDiv"
                    :style="{
                        height: browserSize.height - 120 + 'px',
                        width: '100%'
                    }"
                    style="border: 1px solid grey; position: relative; overflow: auto; "
                    class="pa-2 justify-center align-center"
                >
                    <div
                        ref="backgroundDiv"
                        :style="backgroundStyle"
                        class="justify-center"
                    >
                        <v-skeleton-loader
                            :loading="$apollo.queries.greenhouse.loading"
                            max-width="100%"
                            height="100%"
                            tile
                            type="table"
                        >
                            <!-- greenhouse frame -->
                            <div
                                :style="[
                                    greenhouseBaseStyles,
                                    greenhouseDynamicStyles
                                ]"
                            >
                                <!-- department -->
                                <VueDraggableResizable
                                    v-for="(department,
                                    department_index) in greenhouse
                                        .greenhouseDepartmentSet.edges"
                                    :key="department_index"
                                    :w="department.node.width"
                                    :h="department.node.height"
                                    :x="department.node.layoutX"
                                    :y="department.node.layoutY"
                                    :z="department.node.z || 100"
                                    :min-width="10"
                                    :min-height="10"
                                    :active.sync="department.node.active"
                                    :draggable="departmentEditable"
                                    :resizable="departmentEditable"
                                    :drag-cancel="'.drag-cancel'"
                                    :parent="true"
                                    :prevent-deactivation="isEditing"
                                    :scale="scale"
                                    :grid="[10, 10]"
                                    :style="{
                                        backgroundColor: department.node
                                            .isPlaceholder
                                            ? 'grey'
                                            : '#EFEBE9'
                                    }"
                                    @activated="
                                        onDepartmentActivated(
                                            ...arguments,
                                            department_index
                                        )
                                    "
                                    @deactivated="
                                        onDepartmentDeactivated(
                                            ...arguments,
                                            department_index
                                        )
                                    "
                                    @dragging="onDepartmentDrag(...arguments)"
                                    @dragstop="
                                        onDepartmentDragStop(
                                            ...arguments,
                                            department_index
                                        )
                                    "
                                    @resizing="onDepartmentResize(...arguments)"
                                    @resizestop="
                                        onDepartmentResizeStop(
                                            ...arguments,
                                            department_index
                                        )
                                    "
                                    class-name-active="elevation-10"
                                >
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <div
                                                v-on="on"
                                                class="d-flex align-center justify-space-around"
                                                :style="
                                                    departmentBaseStyles(
                                                        department.node.width,
                                                        department.node.height,
                                                        department_index
                                                    )
                                                "
                                            >
                                                <!-- department placeholder -->
                                                <span
                                                    v-if="
                                                        department.node
                                                            .isPlaceholder
                                                    "
                                                    class="title white--text text-center"
                                                    >{{
                                                        department.node.name
                                                    }}</span
                                                >

                                                <!-- section -->
                                                <VueDraggableResizable
                                                    v-for="(section,
                                                    section_index) in department
                                                        .node
                                                        .greenhouseDepartmentSectionSet
                                                        ? department.node
                                                              .greenhouseDepartmentSectionSet
                                                              .edges
                                                        : []"
                                                    :key="section_index"
                                                    :w="section.node.width"
                                                    :h="section.node.height"
                                                    :x="section.node.layoutX"
                                                    :y="section.node.layoutY"
                                                    :z="section.node.z || 100"
                                                    :min-width="10"
                                                    :min-height="10"
                                                    :active.sync="
                                                        section.node.active
                                                    "
                                                    :draggable="sectionEditable"
                                                    :resizable="sectionEditable"
                                                    :parent="true"
                                                    :prevent-deactivation="
                                                        isEditing
                                                    "
                                                    :scale="scale"
                                                    @activated="
                                                        onSectionActivated(
                                                            ...arguments,
                                                            department_index,
                                                            section_index
                                                        )
                                                    "
                                                    @deactivated="
                                                        onSectionDeactivated(
                                                            ...arguments,
                                                            department_index,
                                                            section_index
                                                        )
                                                    "
                                                    @dragging="
                                                        onSectionDrag(
                                                            ...arguments
                                                        )
                                                    "
                                                    @dragstop="
                                                        onSectionDragStop(
                                                            ...arguments,
                                                            department_index,
                                                            section_index
                                                        )
                                                    "
                                                    @resizing="
                                                        onSectionResize(
                                                            ...arguments
                                                        )
                                                    "
                                                    @resizestop="
                                                        onSectionResizeStop(
                                                            ...arguments,
                                                            department_index,
                                                            section_index
                                                        )
                                                    "
                                                    style="backgroundColor: white"
                                                    class-name-active="elevation-10"
                                                    heiht="100%"
                                                    width="100%"
                                                    class="drag-cancel"
                                                >
                                                    <v-tooltip bottom>
                                                        <template
                                                            v-slot:activator="{
                                                                on
                                                            }"
                                                        >
                                                            <v-card
                                                                v-on="on"
                                                                class="d-flex align-center justify-space-around overflow-hidden"
                                                                height="100%"
                                                                width="100%"
                                                                tile
                                                                :style="{
                                                                    backgroundColor: section
                                                                        .node
                                                                        .isPlaceholder
                                                                        ? 'grey'
                                                                        : 'rgba(0, 255, 0, ' +
                                                                          (section
                                                                              .node
                                                                              .usedRate ||
                                                                              0) +
                                                                          ')'
                                                                }"
                                                            >
                                                                <span
                                                                    :class="[
                                                                        section
                                                                            .node
                                                                            .isPlaceholder
                                                                            ? 'white--text headline'
                                                                            : 'display-1'
                                                                    ]"
                                                                    >{{
                                                                        section
                                                                            .node
                                                                            .name
                                                                    }}</span
                                                                >
                                                            </v-card>
                                                        </template>
                                                        <span
                                                            v-if="
                                                                section.node
                                                                    .isPlaceholder
                                                            "
                                                            >{{
                                                                section.node
                                                                    .name
                                                            }}</span
                                                        >
                                                        <span v-else
                                                            >{{
                                                                (
                                                                    ((section
                                                                        .node
                                                                        .width /
                                                                        meterToPixelRatio) *
                                                                        section
                                                                            .node
                                                                            .height) /
                                                                        meterToPixelRatio -
                                                                    (section
                                                                        .node
                                                                        .usedSpaceM2 ||
                                                                        0)
                                                                ).toFixed(0)
                                                            }}m2 ({{
                                                                (
                                                                    ((section
                                                                        .node
                                                                        .width /
                                                                        meterToPixelRatio) *
                                                                        section
                                                                            .node
                                                                            .height) /
                                                                    meterToPixelRatio
                                                                ).toFixed(0)
                                                            }}m2)</span
                                                        >
                                                    </v-tooltip>
                                                </VueDraggableResizable>
                                            </div>
                                        </template>
                                        <span
                                            v-if="department.node.isPlaceholder"
                                            >{{ department.node.name }}</span
                                        >
                                        <span v-else>
                                            <b>{{ department.node.name }}</b>
                                            -
                                            {{
                                                (
                                                    department.node
                                                        .totalSpaceM2 -
                                                    department.node
                                                        .totalUsedSpaceM2
                                                ).toFixed(2)
                                            }}m2 ({{
                                                department.node.totalSpaceM2
                                            }}m2)
                                        </span>
                                    </v-tooltip>
                                </VueDraggableResizable>
                            </div>
                        </v-skeleton-loader>
                    </div>
                </div>
            </v-col>
        </v-row>

        <!-- section bottom sheet -->
        <v-bottom-sheet
            v-model="sectionBottomSheet"
            hide-overlay
            persistent
            no-click-animation
        >
            <v-sheet class="text-center">
                <v-card>
                    <v-card-actions class="justify-space-between py-0">
                        <v-switch
                            v-model="editedSection.isPlaceholder"
                            :label="`Placeholder`"
                            small
                        ></v-switch>
                        <v-spacer />
                        <span class="headline">{{ editedSection.name }}</span>
                        <v-spacer />
                        <v-btn
                            color="error"
                            class="elevation-0"
                            fab
                            x-small
                            @click="onDeletingSection"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">delete_forever</v-icon>
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                        </v-btn>
                        <v-btn
                            color="grey lighten-3"
                            class="elevation-0"
                            fab
                            x-small
                            @click="cancelEditedSection"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">close</v-icon>
                                </template>
                                <span>Close</span>
                            </v-tooltip>
                        </v-btn>
                        <v-btn
                            color="primary"
                            class="elevation-0"
                            fab
                            x-small
                            @click="saveEditedSection"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">check</v-icon>
                                </template>
                                <span>Save</span>
                            </v-tooltip>
                        </v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <v-form ref="section-form">
                            <v-row align="center" dense class="mb-n3">
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="editedSection.name"
                                        :rules="[
                                            rules.required,
                                            rules.maxLength(50)
                                        ]"
                                        label="Name*"
                                        outlined
                                        :disabled="!isEditing"
                                        class="subtitle-2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="6" md="2">
                                    <v-text-field
                                        v-model="editedSection.width"
                                        :rules="[rules.required]"
                                        label="Width*"
                                        type="number"
                                        suffix="m"
                                        outlined
                                        :disabled="!isEditing"
                                        class="subtitle-2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="6" md="2">
                                    <v-text-field
                                        v-model="editedSection.height"
                                        :rules="[rules.required]"
                                        label="Height*"
                                        type="number"
                                        suffix="m"
                                        outlined
                                        :disabled="!isEditing"
                                        class="subtitle-2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="6" md="2">
                                    <v-text-field
                                        v-model="editedSection.layoutY"
                                        :rules="[rules.required]"
                                        label="Top*"
                                        type="number"
                                        suffix="m"
                                        outlined
                                        :disabled="!isEditing"
                                        class="subtitle-2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="6" md="2">
                                    <v-text-field
                                        v-model="editedSection.layoutX"
                                        :rules="[rules.required]"
                                        label="Left*"
                                        type="number"
                                        suffix="m"
                                        outlined
                                        :disabled="!isEditing"
                                        class="subtitle-2"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-sheet>
        </v-bottom-sheet>

        <!-- department bottom sheet -->
        <v-bottom-sheet
            v-model="departmentBottomSheet"
            hide-overlay
            persistent
            no-click-animation
        >
            <v-sheet class="text-center">
                <v-card>
                    <v-card-actions class="justify-space-between py-0">
                        <v-switch
                            v-model="editedDepartment.isPlaceholder"
                            :label="`Placeholder`"
                            small
                        ></v-switch>
                        <v-spacer />
                        <span class="headline">{{
                            editedDepartment.name
                        }}</span>
                        <v-spacer />
                        <v-btn
                            color="error"
                            class="elevation-0"
                            fab
                            x-small
                            @click="onDeletingDepartment"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">delete_forever</v-icon>
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                        </v-btn>
                        <v-btn
                            color="grey lighten-3"
                            class="elevation-0"
                            fab
                            x-small
                            @click="cancelEditedDepartment"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">close</v-icon>
                                </template>
                                <span>Close</span>
                            </v-tooltip>
                        </v-btn>
                        <v-btn
                            color="primary"
                            class="elevation-0"
                            fab
                            x-small
                            @click="saveEditedDepartment"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">check</v-icon>
                                </template>
                                <span>Save</span>
                            </v-tooltip>
                        </v-btn>
                    </v-card-actions>

                    <v-card-text>
                        <v-form ref="section-form">
                            <v-row align="center" dense>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="editedDepartment.name"
                                        :rules="[
                                            rules.required,
                                            rules.maxLength(50)
                                        ]"
                                        label="Name*"
                                        outlined
                                        :disabled="!isEditing"
                                        class="subtitle-2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="6" md="2">
                                    <v-text-field
                                        v-model="editedDepartment.width"
                                        :rules="[rules.required]"
                                        label="Width*"
                                        type="number"
                                        suffix="m"
                                        outlined
                                        :disabled="!isEditing"
                                        class="subtitle-2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="6" md="2">
                                    <v-text-field
                                        v-model="editedDepartment.height"
                                        :rules="[rules.required]"
                                        label="Height*"
                                        type="number"
                                        suffix="m"
                                        outlined
                                        :disabled="!isEditing"
                                        class="subtitle-2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="6" md="2">
                                    <v-text-field
                                        v-model="editedDepartment.layoutY"
                                        :rules="[rules.required]"
                                        label="Top"
                                        type="number"
                                        suffix="m"
                                        outlined
                                        :disabled="!isEditing"
                                        class="subtitle-2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="6" md="2">
                                    <v-text-field
                                        v-model="editedDepartment.layoutX"
                                        :rules="[rules.required]"
                                        label="Left*"
                                        type="number"
                                        suffix="m"
                                        outlined
                                        :disabled="!isEditing"
                                        class="subtitle-2"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row align="center" class="mb-n5">
                                <v-col
                                    cols="12"
                                    md="5"
                                    v-if="!editedDepartment.isPlaceholder"
                                >
                                    <v-range-slider
                                        v-model="
                                            editedDepartment.temperatureRange
                                        "
                                        min="10,"
                                        max="40,"
                                        color="primary"
                                        track-color="grey lighten-2"
                                        prepend-icon="fa-thermometer-half"
                                        thumb-size="24"
                                        thumb-label="always"
                                        label="°C"
                                    ></v-range-slider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="5"
                                    v-if="!editedDepartment.isPlaceholder"
                                >
                                    <v-range-slider
                                        v-model="editedDepartment.humidityRange"
                                        color="primary"
                                        track-color="grey lighten-2"
                                        prepend-icon="fa-tint"
                                        thumb-size="24"
                                        thumb-label="always"
                                        label="%"
                                    ></v-range-slider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="2"
                                    class="mt-n5"
                                    v-if="!editedDepartment.isPlaceholder"
                                >
                                    <v-switch
                                        v-model="editedDepartment.pesticide"
                                        label="Pesticide"
                                        color="primary"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-sheet>
        </v-bottom-sheet>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import Config from "@/utils/config.json";
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import GreenhouseDepartmentEditDialog from "@/components/greenhouse/GreenhouseDepartmentEditDialog.vue";
import GreenhouseDepartmnetSectionAddDialog from "@/components/greenhouse/GreenhouseDepartmentSectionAddDialog.vue";
import GreenhouseDepartmnetSectionTasksDialog from "@/components/greenhouse/GreenhouseDepartmentSectionTasksDialog.vue";
import GrowthTaskEditDialog from "@/components/growth/GrowthTaskEditDialog.vue";
import DeleteDialog from "@/components/base/DeleteDialog.vue";

export default {
    name: "greenhouse-detail-page",
    components: {
        VueDraggableResizable,
        GreenhouseDepartmentEditDialog,
        GreenhouseDepartmnetSectionAddDialog,
        GreenhouseDepartmnetSectionTasksDialog,
        GrowthTaskEditDialog,
        DeleteDialog
    },

    apollo: {
        greenhouse: {
            query: gql`
                query greenhouse($id: ID!) {
                    greenhouse(id: $id) {
                        id
                        name
                        width
                        height
                        greenhouseDepartmentSet {
                            edges {
                                node {
                                    id
                                    name
                                    totalSpaceM2
                                    totalUsedSpaceM2
                                    totalUsedRate
                                    isPlaceholder
                                    layoutX
                                    layoutY
                                    width
                                    height
                                    greenhouseDepartmentSectionSet {
                                        edges {
                                            node {
                                                id
                                                name
                                                spaceM2
                                                usedSpaceM2
                                                usedRate
                                                isPlaceholder
                                                layoutX
                                                layoutY
                                                width
                                                height
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    id: this.$route.params.id
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update(data) {
                //send data to parent component
                this.$emit("item-fetched", data.greenhouse);

                if (!data.greenhouse) {
                    alert("Unknown greenhouse!");
                }

                setTimeout(() => {
                    this.scrollToCenter(data.greenhouse);
                }, 500);
                this.fitWidnowSize(data.greenhouse);

                // scroll to greenhouse layout
                this.$vuetify.goTo(this.$refs.layout, { duration: 300 });

                //return result to current componet
                return data.greenhouse;
                // return JSON.parse(JSON.stringify(data.product));
            }
            // pollInterval: 60000 // ms
        }
    },

    data: function() {
        return {
            // isLoadingGreenhouse: false,
            scale: 1,

            editGreenhouseDepartmentDialog: false,
            addGreenhouseDepartmentSectionDialog: false,
            sectionDetaildialog: false,
            growthTaskEditDialog: false,
            deleteItemDialog: false,

            isSaving: false,
            isEditing: false,
            hasUnsavedChange: false,

            selectedSectionIndex: null,
            selectedSectionDepartmentIndex: null,
            selectedDepartmentIndex: null,
            selectedSectionNodeId: null,

            editedSection: {
                department_index: null,
                section_index: null,
                sectionNodeId: null,
                name: "",
                isPlaceholder: false,
                layoutX: 0,
                layoutY: 0,
                width: 10,
                height: 10
            },
            editedDepartment: {
                department_index: null,
                departmentNodeId: null,
                name: "",
                isPlaceholder: false,
                layoutX: 0,
                layoutY: 0,
                width: 10,
                height: 10,
                temperatureRange: [20, 30],
                humidityRange: [40, 60],
                pesticide: false
            },

            deletingItem: {
                type: null,
                object: null
            },

            sectionBottomSheet: false,
            departmentBottomSheet: false,

            greenhouse: {
                id: "",
                name: "",
                description: "",
                width: 1000,
                height: 1000,
                greenhouseDepartmentSet: {
                    edges: [
                        {
                            node: {
                                id: "",
                                name: "",
                                width: 500,
                                height: 500,
                                greenhouseDepartmentSectionSet: {
                                    edges: [
                                        {
                                            node: {
                                                id: "",
                                                name: "",
                                                width: 400,
                                                height: 40
                                            }
                                        }
                                    ]
                                }
                            }
                        }
                    ]
                },
                originalGreenhouse: null
            },
            rules: {
                required: v => !helper.isEmpty(v) || "This field is required",
                listRequired: v =>
                    (v || "").length >= 1 || `This field is required`,
                minLength: len => v =>
                    (v || "").length >= len || `Require at least ${len}`,
                maxLength: len => v => (v || "").length <= len || "Too long"
                // nameRules: [
                //     v => !!v || "Name is required",
                //     v =>
                //         v.length <= 50 || "Name must be less than 50 characters"
                // ]
            }
        };
    },
    computed: {
        meterToPixelRatio() {
            return Config.meterToPixelRatio;
        }, // 1 meter = 10 pixels
        sectionEditable() {
            return this.isEditing && this.selectedSectionIndex !== null;
        },
        departmentEditable() {
            return (
                this.isEditing &&
                this.editedDepartment.department_index !== null &&
                this.editedSection.section_index === null
            );
        },

        ////////////////////////////////
        // selected department and section
        ////////////////////////////////
        selectedSectionNode() {
            if (this.editedSection.department_index !== null) {
                const sectionNode = this.greenhouse.greenhouseDepartmentSet
                    .edges[this.editedSection.department_index].node
                    .greenhouseDepartmentSectionSet.edges[
                    this.editedSection.section_index
                ].node;

                return sectionNode;
            } else {
                return null;
            }
        },
        selectedDepartmentNode() {
            if (this.editedDepartment.department_index !== null) {
                const departmentNode = this.greenhouse.greenhouseDepartmentSet
                    .edges[this.editedDepartment.department_index].node;

                return departmentNode;
            } else {
                return null;
            }
        },

        ////////////////////////////////
        // enable / disable buttons
        ////////////////////////////////
        disableDeleteButton() {
            return (
                this.editedDepartment.department_index === null &&
                this.editedSection.department_index === null
            );
        },
        disableAddDepartmentButton() {
            return (
                this.editedDepartment.department_index !== null ||
                this.editedSection.department_index !== null
            );
        },
        disableAddSectionButton() {
            return this.editedDepartment.department_index === null;
        },
        // disableCopySectionButton() {
        //     return (
        //         this.editedSection.department_index === null &&
        //         this.editedSection.section_index === null
        //     );
        // },

        browserSize() {
            return {
                width: window.innerWidth,
                height: window.innerHeight
            };
        },
        backgroundStyle() {
            return {
                width: this.greenhouse.width * 2 + "px",
                height: this.greenhouse.height * 2 + "px",
                position: "relative",
                margin: "0"
            };
        },
        greenhouseBaseStyles() {
            return {
                width: this.greenhouse.width + 1 + "px",
                height: this.greenhouse.height + 1 + "px",
                position: "relative",
                margin: "auto",
                border: "1px solid grey",
                background: this.departmentEditable
                    ? "linear-gradient(-90deg, rgba(0, 0, 0, .1) 1px, transparent 1px), linear-gradient(rgba(0, 0, 0, .1) 1px, transparent 1px)"
                    : null,
                backgroundColor: this.departmentEditable ? "#F5F5F5" : "null",
                backgroundSize: this.departmentEditable
                    ? "10px 10px, 10px 10px"
                    : null
            };
        },
        greenhouseDynamicStyles() {
            return {
                transform: "scale(" + this.scale + ")",
                transformOrigin: "center top"
            };
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    watch: {
        isEditing(val) {
            if (!val) {
                this.departmentBottomSheet = false;
                this.sectionBottomSheet = false;
            }
        },
        editedSection() {
            if (this.isEditing) {
                this.hasUnsavedChange = true;
            }
        },
        editedDepartment() {
            if (this.isEditing) {
                this.hasUnsavedChange = true;
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.hasUnsavedChange) {
            const answer = window.confirm(
                "Do you really want to leave? you have unsaved changes!"
            );
            if (answer) {
                this.onCancelEditing();
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    },
    methods: {
        // initialize() {
        //     this.fecthGreenhouse();
        //     // this.fetchCustomers();
        // },

        // fecthGreenhouse() {
        //     // console.log("fecthGreenhouse");

        //     this.isLoadingGreenhouse = true;

        //     this.$store
        //         .dispatch(
        //             "greenhouses/fetchSingleGreenhouse",
        //             this.$route.params.id
        //         )
        //         .then(response => {
        //             this.greenhouse = response;

        //             setTimeout(() => {
        //                 this.scrollToCenter();
        //                 this.isLoadingGreenhouse = false;
        //             }, 500);

        //             this.fitWidnowSize();

        //             // scroll to greenhouse layout
        //             this.$vuetify.goTo(this.$refs.layout, { duration: 300 });
        //         })
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //             this.isLoadingGreenhouse = false;
        //         })
        //         .finally(() => {});
        // },

        // fetchCustomers() {
        //     this.$store
        //         .dispatch("customers/fetchCustomers")
        //         .then(() => {})
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //         })
        //         .finally();
        // },

        onAddGrowthTaskConfirmed() {
            // this.fecthGreenhouse();
            this.$apollo.queries.greenhouse.refresh();
        },

        fitWidnowSize(greenhouse) {
            // console.log(greenhouse);
            const scaleX = (this.browserSize.width - 72) / greenhouse.width;
            const scaleY = (this.browserSize.height - 130) / greenhouse.height;

            this.scale = Math.min(scaleX, scaleY, 1);
        },
        originalWidnowSize() {
            this.scale = 1;
        },
        zoomOut() {
            this.scale = this.scale - 0.1 || 0;
        },
        zoomIn() {
            this.scale = this.scale + 0.1 || 1;
        },

        scrollToCenter(greenhouse) {
            // console.log("scrollToCenter is called!");
            var outerDiv = this.$refs["frameDiv"];
            // var backgroundDiv = this.$refs["backgroundDiv"];
            outerDiv.scrollLeft = greenhouse.width - outerDiv.offsetWidth / 2;
        },

        departmentBaseStyles(width, height, department_index) {
            return {
                width: width - 2 + "px",
                height: height - 2 + "px",
                position: "relative",
                margin: "auto",
                border: "none !important",
                background:
                    this.isEditing &&
                    this.editedSection.department_index === department_index
                        ? "linear-gradient(-90deg, rgba(0, 0, 0, .1) 1px, transparent 1px), linear-gradient(rgba(0, 0, 0, .1) 1px, transparent 1px)"
                        : null,
                backgroundColor: "transparent",
                backgroundSize:
                    this.isEditing &&
                    this.editedSection.department_index === department_index
                        ? "10px 10px, 10px 10px"
                        : null
            };
        },

        ////////////////////////////////
        // delete functions
        ////////////////////////////////

        // onDeletingItem() {
        //     this.sectionBottomSheet = false;
        //     this.departmentBottomSheet = false;

        //     if (this.editedDepartment.department_index !== null) {
        //         this.deletingItem.type = "Department";
        //         this.deletingItem.object = this.editedDepartment;
        //     }

        //     if (
        //         this.editedSection.department_index !== null &&
        //         this.editedSection.section_index !== null
        //     ) {
        //         this.deletingItem.type = "Section";
        //         this.deletingItem.object = this.editedSection;
        //     }

        //     this.deleteItemDialog = true;
        // },
        onAddDepartmentSections() {
            this.sectionBottomSheet = false;
            this.departmentBottomSheet = false;
            this.addGreenhouseDepartmentSectionDialog = true;
        },

        onAddDepartmentSectionsConfirmed(newSections) {
            // var _selectedDepartmentNode = this.selectedDepartmentNode;
            var departmentNode = this.greenhouse.greenhouseDepartmentSet.edges[
                this.editedDepartment.department_index
            ].node;

            newSections.forEach(item => {
                departmentNode.greenhouseDepartmentSectionSet.edges.push({
                    node: {
                        name: item.name,
                        isPlaceholder: item.isPlaceholder,
                        layoutX: item.layoutX,
                        layoutY: item.layoutY,
                        width: item.width,
                        height: item.height
                    }
                });
            });

            this.unselectCurrentSection();
            this.unselectCurrentDepartment();
        },

        onDeletingSection() {
            this.sectionBottomSheet = false;
            this.departmentBottomSheet = false;

            this.deletingItem.type = "Section";
            this.deletingItem.object = this.editedSection;

            this.deleteItemDialog = true;
        },

        onDeletingDepartment() {
            this.sectionBottomSheet = false;
            this.departmentBottomSheet = false;

            this.deletingItem.type = "Department";
            this.deletingItem.object = this.editedDepartment;

            this.deleteItemDialog = true;
        },

        onDeleteConfirmed() {
            // if section selected, then delete section
            if (this.deletingItem.type === "Section") {
                this.greenhouse.greenhouseDepartmentSet.edges[
                    this.deletingItem.object.department_index
                ].node.greenhouseDepartmentSectionSet.edges.splice(
                    this.deletingItem.object.section_index,
                    1
                );

                this.editedSection.department_index = null;
                this.editedSection.section_index = null;
            }

            // else delete department
            if (this.deletingItem.type === "Department") {
                this.greenhouse.greenhouseDepartmentSet.edges.splice(
                    this.deletingItem.object.department_index,
                    1
                );

                this.editedDepartment.department_index = null;
            }

            this.deleteItemDialog = false;
            this.deletingItem.type = null;
            this.deletingItem.object = null;
        },

        ////////////////////////////////
        // Sections functions
        ////////////////////////////////
        unselectCurrentSection() {
            // console.log(
            //     "unselectCurrentSection is called! department_index: " +
            //         this.editedSection.department_index +
            //         "; section_index: " +
            //         this.editedSection.section_index
            // );

            // unselect current section
            if (
                this.editedSection.department_index !== null &&
                this.editedSection.section_index !== null
            ) {
                var sectionNode = this.greenhouse.greenhouseDepartmentSet.edges[
                    this.editedSection.department_index
                ].node.greenhouseDepartmentSectionSet.edges[
                    this.editedSection.section_index
                ].node;

                sectionNode.active = false;

                this.editedSection.department_index = null;
                this.editedSection.section_index = null;
            }
        },
        onSectionActivated(department_index, section_index) {
            // console.log(
            //     "onSectionActivated is called! department_index: " +
            //         department_index +
            //         "; section_index: " +
            //         section_index
            // );

            // move selected object zindex to top
            var departmentNode = this.greenhouse.greenhouseDepartmentSet.edges[
                department_index
            ].node;

            var sectionNode =
                departmentNode.greenhouseDepartmentSectionSet.edges[
                    section_index
                ].node;

            sectionNode.z = 200;

            // unselect current department
            this.unselectCurrentDepartment();

            // unselect current section
            if (
                this.editedSection.department_index !== department_index ||
                this.editedSection.section_index !== section_index
            ) {
                this.unselectCurrentSection();
            }

            // prepare bottom sheet
            this.selectedDepartmentIndex = null;
            this.selectedSectionDepartmentIndex = department_index;
            this.selectedSectionIndex = section_index;

            this.setEditedSection(department_index, section_index, sectionNode);

            // show section bottom sheet
            if (this.isEditing) {
                this.departmentBottomSheet = false;
                this.sectionBottomSheet = true;
            } else {
                if (!this.editedSection.isPlaceholder) {
                    this.sectionDetaildialog = true;
                    this.selectedSectionNodeId = sectionNode.id;
                }
            }
        },

        onSectionDeactivated(department_index, section_index) {
            // console.log(
            //     "onSectionDeactivated is called! department_index: " +
            //         department_index +
            //         "; section_index: " +
            //         section_index
            // );

            // move selected object zindex to top
            var sectionNode = this.greenhouse.greenhouseDepartmentSet.edges[
                department_index
            ].node.greenhouseDepartmentSectionSet.edges[section_index].node;

            sectionNode.z = 100;

            if (
                this.editedSection.department_index === department_index &&
                this.editedSection.section_index === section_index &&
                !this.sectionDetaildialog
            ) {
                this.selectedSectionIndex = null;
                this.selectedSectionNodeId = null;
            }
        },
        onSectionResize(x, y, width, height) {
            // console.log("onSectionResize is called! ");

            this.editedSection.layoutX = x / this.meterToPixelRatio;
            this.editedSection.layoutY = y / this.meterToPixelRatio;
            this.editedSection.width = width / this.meterToPixelRatio;
            this.editedSection.height = height / this.meterToPixelRatio;
        },
        onSectionResizeStop(
            x,
            y,
            width,
            height,
            department_index,
            section_index
        ) {
            // console.log(
            //     "onSectionResize is called! department_index: " +
            //         department_index +
            //         "; section_index: " +
            //         section_index
            // );

            var sectionNode = this.greenhouse.greenhouseDepartmentSet.edges[
                department_index
            ].node.greenhouseDepartmentSectionSet.edges[section_index].node;

            sectionNode.layoutX = x;
            sectionNode.layoutY = y;
            sectionNode.width = width;
            sectionNode.height = height;

            this.setEditedSection(department_index, section_index, sectionNode);
        },

        onSectionDrag(x, y) {
            // console.log("onSectionDrag is called! ");

            this.editedSection.layoutX = x / this.meterToPixelRatio;
            this.editedSection.layoutY = y / this.meterToPixelRatio;
        },
        onSectionDragStop(x, y, department_index, section_index) {
            // console.log(
            //     "onSectionDragStop is called! department_index: " +
            //         department_index +
            //         "; section_index: " +
            //         section_index
            // );

            var sectionNode = this.greenhouse.greenhouseDepartmentSet.edges[
                department_index
            ].node.greenhouseDepartmentSectionSet.edges[section_index].node;

            sectionNode.layoutX = x;
            sectionNode.layoutY = y;

            this.setEditedSection(department_index, section_index, sectionNode);
        },
        setEditedSection(department_index, section_index, sectionNode) {
            // console.log(
            //     "setEditedSection is called! department_index: " +
            //         department_index +
            //         "; section_index: " +
            //         section_index
            // );

            this.editedSection = {
                department_index: department_index,
                section_index: section_index,
                sectionNodeId: sectionNode.id,
                name: sectionNode.name,
                isPlaceholder: sectionNode.isPlaceholder,
                layoutX: sectionNode.layoutX / this.meterToPixelRatio,
                layoutY: sectionNode.layoutY / this.meterToPixelRatio,
                width: (sectionNode.width / this.meterToPixelRatio).toFixed(2),
                height: (sectionNode.height / this.meterToPixelRatio).toFixed(2)
            };
        },

        cancelEditedSection() {
            this.unselectCurrentSection();
            this.sectionBottomSheet = false;
        },

        saveEditedSection() {
            if (this.editedSection) {
                var sectionNode = this.greenhouse.greenhouseDepartmentSet.edges[
                    this.editedSection.department_index
                ].node.greenhouseDepartmentSectionSet.edges[
                    this.editedSection.section_index
                ].node;

                sectionNode.name = this.editedSection.name;
                sectionNode.isPlaceholder = this.editedSection.isPlaceholder;
                sectionNode.layoutX = parseInt(
                    this.editedSection.layoutX * this.meterToPixelRatio
                );
                sectionNode.layoutY = parseInt(
                    this.editedSection.layoutY * this.meterToPixelRatio
                );
                sectionNode.width =
                    this.editedSection.width * this.meterToPixelRatio;
                sectionNode.height =
                    this.editedSection.height * this.meterToPixelRatio;
            }

            // close bottom sheet
            this.unselectCurrentSection();
            this.sectionBottomSheet = false;
        },

        ////////////////////////////////
        // Department functions
        ////////////////////////////////
        unselectCurrentDepartment() {
            // console.log(
            //     "unselectCurrentDepartment is called! department_index: " +
            //         this.editedDepartment.department_index
            // );

            // unselect current department
            if (this.editedDepartment.department_index !== null) {
                var departmentNode = this.greenhouse.greenhouseDepartmentSet
                    .edges[this.editedDepartment.department_index].node;

                departmentNode.active = false;

                this.editedDepartment.department_index = null;
            }
        },
        onAddDepartment() {
            this.unselectCurrentSection();
            this.unselectCurrentDepartment();
            this.sectionBottomSheet = false;
            this.departmentBottomSheet = false;
            this.editGreenhouseDepartmentDialog = true;
        },

        onDepartmentAdded(department) {
            this.greenhouse.greenhouseDepartmentSet.edges.push({
                node: department
            });
        },

        onDepartmentActivated(department_index) {
            // console.log(
            //     "onDepartmentActivated is called! department_index: " +
            //         department_index
            // );

            var departmentNode = this.greenhouse.greenhouseDepartmentSet.edges[
                department_index
            ].node;

            // move selected object zindex to top
            departmentNode.z = 200;

            // unselect current section
            this.unselectCurrentSection();

            // unselect current department
            if (this.editedDepartment.department_index !== department_index) {
                this.unselectCurrentDepartment();
            }

            // prepare bottom sheet
            this.selectedDepartmentIndex = department_index;

            this.setEditedDepartment(department_index, departmentNode);

            // show department bottom sheet
            if (this.isEditing) {
                this.sectionBottomSheet = false;
                this.departmentBottomSheet = true;
            }
        },
        onDepartmentDeactivated(department_index) {
            // console.log(
            //     "onDepartmentDeactivated is called! department_index: " +
            //         department_index
            // );

            var departmentNode = this.greenhouse.greenhouseDepartmentSet.edges[
                department_index
            ].node;

            // move selected object zindex to bottom
            departmentNode.z = 100;

            if (this.selectedDepartmentIndex === department_index) {
                this.selectedDepartmentIndex = null;
            }
        },
        onDepartmentResize(x, y, width, height) {
            // console.log("onDepartmentResize is called! ");

            this.editedDepartment.layoutX = x / this.meterToPixelRatio;
            this.editedDepartment.layoutY = y / this.meterToPixelRatio;
            this.editedDepartment.width = width / this.meterToPixelRatio;
            this.editedDepartment.height = height / this.meterToPixelRatio;
        },
        onDepartmentResizeStop(x, y, width, height, department_index) {
            // console.log(
            //     "onDepartmentResize is called! department_index: " +
            //         department_index
            // );

            var departmentNode = this.greenhouse.greenhouseDepartmentSet.edges[
                department_index
            ].node;

            departmentNode.layoutX = x;
            departmentNode.layoutY = y;
            departmentNode.width = width;
            departmentNode.height = height;

            this.setEditedDepartment(department_index, departmentNode);
        },
        onDepartmentDrag(x, y) {
            // console.log("onDepartmentDrag is called! ");

            this.editedDepartment.layoutX = x / this.meterToPixelRatio;
            this.editedDepartment.layoutY = y / this.meterToPixelRatio;
        },
        onDepartmentDragStop(x, y, department_index) {
            // console.log(
            //     "onDepartmentDragStop is called! department_index: " +
            //         department_index
            // );

            var departmentNode = this.greenhouse.greenhouseDepartmentSet.edges[
                department_index
            ].node;

            departmentNode.layoutX = x;
            departmentNode.layoutY = y;

            this.setEditedDepartment(department_index, departmentNode);
        },

        setEditedDepartment(department_index, departmentNode) {
            // console.log(
            //     "setEditedDepartment is called! department_index: " +
            //         department_index
            // );

            this.editedDepartment = {
                department_index: department_index,
                departmentNodeId: departmentNode.id,
                name: departmentNode.name,
                isPlaceholder: departmentNode.isPlaceholder,
                layoutX: departmentNode.layoutX / this.meterToPixelRatio,
                layoutY: departmentNode.layoutY / this.meterToPixelRatio,
                width: departmentNode.width / this.meterToPixelRatio,
                height: departmentNode.height / this.meterToPixelRatio,
                temperatureRange: [
                    departmentNode.temperatureMin,
                    departmentNode.temperatureMax
                ],
                humidityRange: [
                    departmentNode.humidityMin,
                    departmentNode.humidityMax
                ],
                pesticide: departmentNode.pesticide
            };
        },

        cancelEditedDepartment() {
            this.unselectCurrentDepartment();
            this.departmentBottomSheet = false;
        },

        ////////////////////////////////////////////
        onStartEditing() {
            // backup current greenhouse data, (deep copy via JSON.stringify)
            this.originalGreenhouse = JSON.stringify(this.greenhouse);
            this.isEditing = true;
            this.unselectCurrentSection();
            this.unselectCurrentDepartment();
        },

        onCancelEditing() {
            // console.log("onCancelEditing is called!");

            this.cancelEditedSection();
            this.cancelEditedDepartment();

            // restore current greenhouse data, (deep copy via JSON.parse)
            this.greenhouse = JSON.parse(this.originalGreenhouse);
            this.originalGreenhouse = null;
            this.isEditing = false;
            this.hasUnsavedChange = false;
        },

        saveEditedDepartment() {
            if (this.editedDepartment) {
                var departmentNode = this.greenhouse.greenhouseDepartmentSet
                    .edges[this.editedDepartment.department_index].node;

                departmentNode.name = this.editedDepartment.name;
                departmentNode.isPlaceholder = this.editedDepartment.isPlaceholder;
                departmentNode.layoutX = parseInt(
                    this.editedDepartment.layoutX * this.meterToPixelRatio
                );
                departmentNode.layoutY = parseInt(
                    this.editedDepartment.layoutY * this.meterToPixelRatio
                );
                departmentNode.width = parseInt(
                    this.editedDepartment.width * this.meterToPixelRatio
                );
                departmentNode.height = parseInt(
                    this.editedDepartment.height * this.meterToPixelRatio
                );
                departmentNode.temperatureMin = this.editedDepartment.temperatureRange[0];
                departmentNode.temperatureMax = this.editedDepartment.temperatureRange[1];
                departmentNode.humidityMin = this.editedDepartment.humidityRange[0];
                departmentNode.humidityMax = this.editedDepartment.humidityRange[1];
                departmentNode.pesticide = this.editedDepartment.pesticide;
            }

            // close bottom sheet
            this.unselectCurrentDepartment();
            this.departmentBottomSheet = false;
        },

        saveEditing() {
            this.isSaving = true;

            const payload = {
                greenhouseNodeId: this.$route.params.id,
                departmentLayouts: this.greenhouse.greenhouseDepartmentSet.edges.map(
                    department => {
                        return {
                            greenhouseDepartmentNodeId: department.node.id,
                            name: department.node.name,
                            description: department.node.description,
                            temperatureMin: department.node.temperatureMin,
                            temperatureMax: department.node.temperatureMax,
                            humidityMin: department.node.humidityMin,
                            humidityMax: department.node.humidityMax,
                            pesticide: department.node.pesticide,
                            isPlaceholder: department.node.isPlaceholder,
                            layoutX: department.node.layoutX,
                            layoutY: department.node.layoutY,
                            width: department.node.width,
                            height: department.node.height,
                            sectionLayouts: department.node.greenhouseDepartmentSectionSet.edges.map(
                                section => {
                                    return {
                                        greenhouseDepartmentSectionNodeId:
                                            section.node.id,
                                        name: section.node.name,
                                        isPlaceholder:
                                            section.node.isPlaceholder,
                                        layoutX: section.node.layoutX,
                                        layoutY: section.node.layoutY,
                                        width: section.node.width,
                                        height: section.node.height
                                    };
                                }
                            )
                        };
                    }
                )
            };

            this.$store
                .dispatch(
                    "greenhouses/updateGreenhouseDepartmentLayouts",
                    payload
                )
                .then(response => {
                    this.greenhouse = response;

                    // this.fitWidnowSize();
                    this.originalGreenhouse = null;
                    this.isEditing = false;

                    this.hasUnsavedChange = false;

                    // show snackbar
                    const payload = {
                        color: "success",
                        message: `Layout saved`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);
                })
                .catch(error => {
                    /*handle errors*/
                    console.log(error);

                    let _error = error.graphQLErrors
                        .map(error => error.message)
                        .join(", ");

                    // show snackbar
                    const payload = {
                        color: "error",
                        message: _error
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);
                })
                .finally(()=>{
                    this.isSaving = false;
                });
        }
    }
};
</script>

<style scoped>
.crossed {
    background: linear-gradient(
            to top left,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) calc(50% - 0.8px),
            rgba(0, 0, 0, 1) 50%,
            rgba(0, 0, 0, 0) calc(50% + 0.8px),
            rgba(0, 0, 0, 0) 100%
        ),
        linear-gradient(
            to top right,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) calc(50% - 0.8px),
            rgba(0, 0, 0, 1) 50%,
            rgba(0, 0, 0, 0) calc(50% + 0.8px),
            rgba(0, 0, 0, 0) 100%
        );
}
</style>